import { render } from "./LoginView.vue?vue&type=template&id=4799da6a"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=4799da6a&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__